import { render, staticRenderFns } from "./AccountManagerRegistrationWidget.vue?vue&type=template&id=e07cfa3c"
import script from "./AccountManagerRegistrationWidget.vue?vue&type=script&lang=js"
export * from "./AccountManagerRegistrationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports